import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AngularUiModule,
  FooterNavComponent,
  Menu,
} from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';
import { LocaleNavComponent } from '../locale-nav/locale-nav.component';

@Component({
  selector: 'un-footer',
  imports: [
    CommonModule,
    FooterNavComponent,
    AngularUiModule,
    LocaleNavComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  today = new Date();
  productsNav: Menu[] = [
    {
      text: $localize`Programs`,
      link: RoutePath.programs,
    },
    {
      text: $localize`Institutes`,
      link: RoutePath.organisations,
    },
    {
      text: $localize`Tours`,
      link: RoutePath.tours,
    },
    {
      text: $localize`Payments`,
      link: RoutePath.payments,
    },
  ];
  productsNav2: Menu[] = [
    {
      text: $localize`Visa`,
      link: 'Visa',
    },
    {
      text: $localize`Payment`,
      link: '/payments',
    },
    {
      text: $localize`Scholarships`,
      link: '/scholarships',
    },
    {
      text: $localize`Flight`,
      link: '/flight',
    },
  ];
  resourcesNav: Menu[] = [
    {
      text: $localize`Blog`,
      link: 'https://blog.univacity.com',
    },
    {
      text: $localize`Help Center`,
      link: 'https://helpdesk.univacity.com',
    },
    // {
    //   text: $localize`Pricing`,
    //   link: '/pricing',
    // },
    {
      text: $localize`Contact Us`,
      link: RoutePath.contact,
    },
  ];
  companyNav: Menu[] = [
    {
      text: $localize`About`,
      link: '/about',
    },
    {
      text: $localize`Subscribe`,
      link: '/subscribe',
    },
    {
      text: $localize`Contact Us`,
      link: '/contact',
    },
    {
      text: $localize`Careers`,
      link: '/carrers',
    },
    {
      text: $localize`Media Kit`,
      link: '/media-kit',
    },
  ];
  contactNav: Menu[] = [
    {
      text: '+234 706 153 7901',
      link: 'tel:+2347061537901',
    },
    {
      text: 'hi@univacity.com',
      link: 'mailto:hi@univacity.com',
    },
    {
      text: '17 Orchid Road, Eleganza Busstop, Lekki II, Nigeria',
      link: RoutePath.contact,
    },
  ];

  socialNav: Menu[] = [
    {
      text: 'Facebook',
      link: 'https://fb.com/univacityofficial',
    },
    {
      text: 'Instagram',
      link: 'https://instagram.com/univacity_',
    },
    {
      text: 'Twitter',
      link: 'https://twitter.com/univacity_',
    },
    {
      text: 'Linkedin',
      link: 'https://linkedin.com/company/univacity',
    },
  ];

  termsNav: Menu[] = [
    { text: $localize`Terms`, link: RoutePath.terms },
    { text: $localize`Refund Policy`, link: RoutePath.refundPolicy },
    { text: $localize`Privacy Policy`, link: RoutePath.policy },
    { text: $localize`Cookie Policy`, link: RoutePath.cookiePolicy },
  ];
}
